import { Skeleton } from 'shared/ui/skeleton'

import s from './styles.module.scss'

export const PromoSkeleton = () => {
  return (
    <div
      className={s.skeleton}
      aria-busy="true"
    >
      <Skeleton className={s.banner} />

      <div className={s.content}>
        <Skeleton className={s.title} />

        <div className={s.text}>
          <Skeleton className={s.textLine} />
          <Skeleton className={s.textLine} />
          <Skeleton className={s.shortTextLine} />
        </div>

        <div className={s.directionCard}>
          <Skeleton className={s.logo} />

          <div className={s.directionInfo}>
            <Skeleton className={s.direction} />
            <Skeleton className={s.price} />
          </div>

          <Skeleton className={s.directionButton} />
        </div>

        <div className={s.text}>
          <Skeleton className={s.textLine} />
          <Skeleton className={s.shortTextLine} />
        </div>
      </div>

      <Skeleton className={s.actionButton} />
    </div>
  )
}
